import {
  DateTime,
} from 'luxon';

export const formatTimeAgo = (iso) => {
  const now = DateTime.local();
  const past = DateTime.fromISO(iso);

  const passed = ['years', 'months', 'days', 'hours', 'minutes'];
  const diff = now.diff(past, passed);

  for (let i = 0; i < passed.length; i += 1) {
    const p = passed[i];
    const t = diff[p];
    if (t >= 1) {
      return `${Math.floor(t)} ${p} ago`;
    }
  }

  return 'just now';
};
